var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',{staticClass:"jumbotron-fluid text-white"},[_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/","exact":""}},[_c('img',{staticClass:"img-fluid my-3",staticStyle:{"max-width":"300px"},attrs:{"src":require("@/assets/logoKN.png"),"alt":"Homepage Logo"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a53fb192","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jumbotron.vue
// module id = ROfp
// module chunks = 1